/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Timerange_7d1Inputs */

const zh_analytics_timerange_7d1 = /** @type {(inputs: Analytics_Timerange_7d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近 7 天`)
};

const en_analytics_timerange_7d1 = /** @type {(inputs: Analytics_Timerange_7d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 7 days`)
};

const es_analytics_timerange_7d1 = /** @type {(inputs: Analytics_Timerange_7d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 7 días`)
};

/**
* | output |
* | --- |
* | "Last 7 days" |
*
* @param {Analytics_Timerange_7d1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_timerange_7d1 = /** @type {((inputs?: Analytics_Timerange_7d1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Timerange_7d1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_timerange_7d1(inputs)
	if (locale === "en") return en_analytics_timerange_7d1(inputs)
	return es_analytics_timerange_7d1(inputs)
});
export { analytics_timerange_7d1 as "analytics_timeRange_7d" }